<template>
  <tender-form-label :key="index" :label="options.Name" :prop="options.Key" :rules="rules">
    <bear-autocomplete
      v-model="form[options.Key]"
      :attrs="attrs"
      @input="inputChangeHandle"
      @get-auto-items="getAutoItems"
      :options="options"
      :disabled="options.Disabled"></bear-autocomplete>
  </tender-form-label>
</template>
<script>
import BearAutocomplete from "~@/bear-autocomplete/src";
import { mixForFormItem } from "../../../js/mixins";
import tenderHook from "../../../js/hooks";
import utils from "../../../js/utils";
export default {
  name: "FormInputAutocomplete",
  mixins: [mixForFormItem],
  components: { BearAutocomplete },
  created() {
    this.setDefaultValue();
  },
  methods: {
    setDefaultValue() {
      let { form = {}, options = {} } = this;
      utils
        .readyToSetFormItemDefault(form, options)
        .then(() => {
          this.setFormItemValue(options.Value || "");
        })
        .catch(() => null);
    },
    inputChangeHandle(autocompleteObject) {
      let { options = {} } = this;
      let { Refs = [] } = options;
      Refs.forEach((eRef) => {
        let [type, ...args] = eRef;
        switch (type) {
          case "setFormItemWithCustom":
            utils.anoyFunction(() => {
              let [type, ...x] = args;
              tenderHook.setFormItemWithCustom(this, type, options, autocompleteObject, ...x);
            });
            break;
          case "houseHooks":
            utils.anoyFunction(() => {
              let [type, ...x] = args;
              tenderHook.houseHooks(this, type, options, autocompleteObject, ...x, false);
            });
            break;
          case "trafficHooks":
            utils.anoyFunction(() => {
              let [type, ...x] = args;
              tenderHook.trafficHooks(this, type, options, autocompleteObject, ...x, false);
            });
            break;
        }
      });
      this.doValidate();
    },
    getAutoItems(call) {
      let { Options = [], OptionsUrl, OptionsFromStore } = this.options;
      if (OptionsFromStore) {
        call(this.selections[OptionsFromStore])
      } else if (OptionsUrl) {
        this.ajaxAutoItems(OptionsUrl).then((res) => call(res));
      } else {
        call(Options);
      }
    },
  },
};
</script>
